import {
  getLLMConfigEndpoints,
  IGetLLMConfigDTO,
  IGetLLMConfigResponse,
  IUpdateLLMConfigDTO,
  IUpdateLLMConfigResponse,
} from '@/models/llmConfig.model';
import { httpClient, ApiResponse } from '@/utils';

class LLMConfigAPI {
  static getLLMConfig({ channelId }: IGetLLMConfigDTO): ApiResponse<IGetLLMConfigResponse> {
    const { GET_LLM_CONFIG } = getLLMConfigEndpoints({ channelId });
    return httpClient.get<IGetLLMConfigResponse>(GET_LLM_CONFIG);
  }

  static updateLLMConfig({ channelId, ...data }: IUpdateLLMConfigDTO): ApiResponse<IUpdateLLMConfigResponse> {
    const { UPDATE_LLM_CONFIG } = getLLMConfigEndpoints({ channelId });
    return httpClient.patch<IUpdateLLMConfigResponse>(UPDATE_LLM_CONFIG, data);
  }
}

export default LLMConfigAPI;
